export default __webpack_public_path__ + "media/src/assets/images/consolidate-687fe47d1299af76da84ac62a5f207cf.png";